import React from 'react';
import { Row, Col, Empty, Space, Typography, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import AgentCard from '../AgentCard/AgentCard';
import AgentCardSkeleton from '../AgentCardSkeleton/AgentCardSkeleton';

const AgentList = ({ agents, onStatusChange, onSettings, onDelete, skeleton }) => {
    const { t } = useTranslation();
    const ref = React.useRef(null);
    if (skeleton) {
        return (<AgentCardSkeleton />);
    }

    if (agents.length === 0) {
        return (
            <Row style={{ padding: '48px 0' }} justify="center">
                <Col>
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <Space direction="vertical" align="center">
                                <Typography.Title level={5}>{t('no_agents_found')}</Typography.Title>
                                <Typography.Text type="secondary">
                                    {t('click_add_agent_to_create_your_first_one')}
                                </Typography.Text>
                            </Space>
                        }
                    />
                </Col>
            </Row>
        );
    }

    return (
        <Flex justify="center" gap={16} wrap ref={ref}>
            {agents.map(agent => (
                <AgentCard
                    key={agent.id}
                    agent={agent}
                    onStatusChange={onStatusChange}
                    onSettings={onSettings}
                    onDelete={onDelete}
                />
            ))}
        </Flex>
    );
};

export default AgentList;
